import { render, staticRenderFns } from "./CSelectBench.vue?vue&type=template&id=8f5ee214&scoped=true"
import script from "./CSelectBench.vue?vue&type=script&lang=js"
export * from "./CSelectBench.vue?vue&type=script&lang=js"
import style0 from "./CSelectBench.vue?vue&type=style&index=0&id=8f5ee214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5ee214",
  null
  
)

export default component.exports